import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from '@dental-ui/auth';
import { provideAccountAppearance } from '@dental-ui/account-layout';
import { provideI18n } from '@dental-ui/shared/i18n';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withHashLocation()),
    provideHttpClient(withFetch(), withInterceptors([authTokenInterceptor])),
    provideAccountAppearance(),
    provideI18n(['account']),
  ],
};
